import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/document.py DocumentOut.
export interface Document {
  document_id: number;
  name: string;
  type: string;
  quality: string;
  file_name: string;
  description: string;
  length: number;
}

export interface DocumentInput {
  name: string;
  type: string;
  quality: string;
  file_name: string;
  description: string;
  length: number;
}

export async function listDocuments(): Promise<Document[]> {
  const resp = await api.get<APIResponse<Document[]>>("/documents/");
  return unwrap(resp.data);
}

export async function createDocument(body: DocumentInput): Promise<number> {
  const resp = await api.post<APIResponse<{ document_id: number }>>("/documents/", body);
  return unwrap(resp.data).document_id;
}

export async function updateDocument(id: number, body: DocumentInput): Promise<void> {
  await api.put(`/documents/${id}`, body);
}

export async function deleteDocument(id: number): Promise<void> {
  await api.delete(`/documents/${id}`);
}
